module.exports = __webpack_public_path__ + "static/media/HYDRAULICS White@3x.26b6ef02.png";